<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		</div>
		<div class="mb-2 mt-2 pt-3" ref="searchDiv">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索 商品名稱|SKU" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
					<!-- <el-tag >總充值：{{total_list.total}}</el-tag> -->
				<!-- 	<el-button class="mr-2"  @click="openModel(false)" type="primary" size="mini" 
					v-auth="'add'+auth_val">申請修改</el-button> -->
					<!-- <el-button type="danger" v-auth="'del'+auth_val" @click="deleteAll" size="mini">批量删除</el-button> -->

				</template>

				<!-- 高級搜索 1-->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="基础搜索" class="mb-0">
							<el-input size="small" v-model="from.name" placeholder="搜索商品名稱|SKU"></el-input>
						</el-form-item>
						
						<el-form-item label="商戶">
							<el-select v-model="from.shop_id" multiple  clearable size="small" filterable placeholder="請選擇" style="width: 85%;">
								<!-- <el-option  label="全部" :value="-1"> -->
								<!-- </el-option> -->
								<el-option v-for="item in shop_list" :key="item.id" :label="item.name+'（'+item.username+')'" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					
						
						
					
						<el-form-item label="狀態" class="mb-0">
							<el-select v-model="from.status" size="small" placeholder="請選擇查看類型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="待审核" :value="0"></el-option>
								<el-option label="通过" :value="1"></el-option>
								<el-option label="拒绝" :value="2"></el-option>
							</el-select>
						</el-form-item>
					
				
						
				

					
						
					


						<el-form-item label="提交時間" size="small" class="mb-0">
							<el-date-picker v-model="from.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
							 range-separator="至" start-placeholder="開始日期" end-placeholder="結束日期" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>

						

						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜索 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>

					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange" :max-height="tableHeight">
				<!-- <el-table-column type="selection" width="45" align="center">

				</el-table-column> -->
				<el-table-column fixed align="center" type="index" label="排序" width="50">
				</el-table-column>
				
				
				<el-table-column align="center" width="60" prop="id" label="ID">
				</el-table-column>
				
				
				
			
				
				<el-table-column align="center" prop="sp_name" width="150" label="对应商戶">
					<template slot-scope="v">
						<span>{{v.row.shop_name}}(<span class="text-danger">{{v.row.username}}</span>)</span>
						
						
					</template>
				</el-table-column>
				
				<el-table-column align="center" width="100"  prop="status"  label="狀態">
					<template slot-scope="v">
						<span style="color: #999;" v-if="v.row.status==0">待审核</span>
						<span class="text-success" v-if="v.row.status==1">通过</span>
						<span class="text-danger" v-if="v.row.status==2">拒绝
					
						</span>
					</template>
				</el-table-column>
				
				<el-table-column align="center" width="100"  prop="status_remark"  label="审核備註">
				</el-table-column>
				
				
				
				<el-table-column align="center" prop="head"  label="商品图片">
					<template slot-scope="v">
						<el-image v-if="v.row.head" style="width: 40px; height: 40px" :src="v.row.head" :preview-src-list="[v.row.head]"></el-image>
					</template>
				</el-table-column>
						
				
				<el-table-column align="center" width="180" prop="name" label="商品名稱">
				</el-table-column>
				
							
				
				<el-table-column align="center" prop="sku" width="180" label="SKU">
							
				</el-table-column>
							
				
				
				<el-table-column align="center" width="180" prop="head"  label="商品条形碼">
					<template slot-scope="v">
						<el-image style="width: 140px; height: 40px" :src="v.row.sku_img" :preview-src-list="[v.row.sku_img]"></el-image>
					</template>
				</el-table-column>
				
				<el-table-column align="center" prop="model" width="100"  label="规格/型號"></el-table-column>
				
				
				<el-table-column align="center" prop="money"  label="价值"></el-table-column>
				<el-table-column align="center" prop="weight" width="100" label="重量(KG)"></el-table-column>
				<el-table-column align="center" prop="len"  width="120" label="尺寸(CM)">
					<template slot-scope="v">
						<span>{{v.row.len}} * {{v.row.width}} * {{v.row.height}}</span>
					</template>
				</el-table-column>
				
				
				
							
				
				<el-table-column align="center" prop="hs_code" width="140"  label="海关编碼"></el-table-column>
				<el-table-column align="center" prop="class_name" width="140"  label="产品分類"></el-table-column>
				<el-table-column align="center" prop="class_name" width="100"  label="产品類型">
					<template slot-scope="v">
						<span  v-if="v.row.pro_type==1">單个产品</span>
						<span  v-if="v.row.pro_type==2">組合产品</span>
						
					</template>
				</el-table-column>
				<el-table-column align="center" prop="class_name"  label="含电池">
					<template slot-scope="v">
						<span  v-if="v.row.pro_type==1">包含</span>
						<span  v-if="v.row.pro_type==0">不包含</span>
						
					</template>
				</el-table-column>
				
				<el-table-column align="center" prop="packing" width="100"  label="包装材质"></el-table-column>
				
				<el-table-column align="center" prop="color" width="100"  label="颜色"></el-table-column>
				
				<el-table-column align="center" prop="p_val1" width="200"  label="TikTok-SKU"></el-table-column>
				<el-table-column align="center" prop="p_val2" width="200"  label="Shopee-SKU"></el-table-column>
				<el-table-column align="center" prop="p_val3" width="200"  label="Lazada-SKU"></el-table-column>
				<el-table-column align="center" prop="remark" width="100"  label="備註"></el-table-column>
				
				
				
				<el-table-column align="center" prop="create_time" width="200" label="提交時間">
					
				</el-table-column>
				
			
				
				

<el-table-column prop="id" :fixed="this.layout.is_phone?false:'right'" align="center" width="140" label="操作">
					<template slot-scope="scope">
						<el-button-group v-if="scope.row.status==0">
							
							
							
							<el-button v-auth="'edit'+auth_val" size="mini" plain type="primary" @click="openModel(scope.row,1)">通过</el-button>
							
							<el-button @click="openModel(scope.row,2)"  v-auth="'edit'+auth_val" size="mini" plain type="danger">拒绝</el-button>

						</el-button-group>
					</template>
				</el-table-column>


				
			</el-table>
		</div>


		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed all_foot_page" >
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>



		<el-dialog  :close-on-click-modal="false" :title="form.status==1?'通过':'拒绝'" :visible.sync="createModel" 
		top="5vh" :width="layout.is_phone?'90%':'50%'">
			<!-- 表單内容 -->
			<el-form :rules="rules" ref="formEdit" :model="form" :label-width="layout.is_phone?'80px':'100px'" :label-position="layout.is_phone?'top':'left'">
				
				
				
				<el-form-item label="商品名稱" prop="name">
					{{form.name}}
				</el-form-item>
				
				<el-form-item label="SKU" prop="sku">
					{{form.sku}}
				</el-form-item>

				
				
				<el-form-item label="审核備註" prop="status_remark">
					<el-input type="textarea" :rows="6" v-model="form.status_remark" 
					placeholder="請輸入审核備註" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
			

				
				
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">確 定</el-button>
			</div>
		</el-dialog>
		

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				rules: {
					status_remark: [{
							required: true,
							message: "請輸入审核備註",
							trigger: 'blur',
						},
					],
					
					
				},
				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					name: '',
					shop_id:'',
					status:-1,
					time: [],
				},
				
				model_title: 'Product',
				auth_val: 'Product',
				preUrl: "data/productList", //列表地址
				addUrl: "data/addProduct", //添加/修改地址
				editStatusUrl: "data/editStatusProduct", //修改狀態地址
				tableData: [],
				form: {
					id: 0,
					status:0,
					status_remark:''
					
				},
				shop_list:[],
				prop: 'create_time',
				sort: 'descending',
				rule_list: [],
				total_list: [],
				check_img_list: [],
				fileList: [],
			}
		},
		watch: {
			activeName(e) {
				console.log(e);
			}
		},
		created() {
			this.commonList('shopList');
		},
		methods: {
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					
					let list = all.data.list
					this.shop_list = list
					
			
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			
			successApply(e){
				this.$confirm('是否確定同意店長的修改申請, 是否继续?', '提示', {
					  confirmButtonText: '確定',
					  cancelButtonText: '取消',
					  type: 'warning'
					}).then(() => {
					  this.form = {
					  	id:  e.id,
					  	status:1,
					  	status_remark:''
					  }
					  this.addOrEdit(this.form)
					}).catch(() => {
					       
					});
			},
			
			handleClick(tab, event) {
				this.search = ''
				this.clearSearch()
				this.getList()
			},
			sortChange(column) {

				this.prop = column.prop
				this.sort = column.order
				this.getList()
			},
			//提交
			submit() {
				
				
				this.$refs.formEdit.validate(res => {
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form,true)
						// 關閉模态框
					}
				})
			},
			
		
			handleAvatarSuccess(res, file) {
				this.form.img = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.head = res.encryption.data.list.url
				}
			  },
			
			  beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 2;
		
				// if (!isJPG) {
				//   this.$message.error('上傳头像图片只能是 JPG 格式!');
				// }
				// if (!isLt2M) {
				//   this.$message.error('上傳头像图片大小不能超過 2MB!');
				// }
				return isJPG && isLt2M;
			  },
			

			// 打开模态框
			openModel(e,type) {
				// 修改
				if(e){
					this.form = {
						id:  e.id,
						name:e.name,
						sku:e.sku,
						status: type,
						status_remark: '',
					}
					this.editIndex = e.id
				}else{
					this.form = {
						id: 0,
						name:'',
						img:"",
						head:'',
						local:''
					}
					this.editIndex = -1
				}
				
				// 打开dialog
				this.createModel = true
			},

			//公共列表

			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.total_list = e.total_list
				this.check_img_list = e.list.map(item => {
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					shop_id:'',
					status:-1,
					time: [],
				}

				this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
</style>
